import type { FilterValues } from "@/components/ui/FilterBar/types";
import type { MultiSelectOption } from "@/components/ui/MultiSelect";
import type { ComercialUnitRow } from "@/services/comercial";
import type { OutcomeItem } from "@/services/financeiro";
import type { ChaoPhysicalMonthPoint, ChaoPhysicalWeekPoint, ChaoUnitMetrics } from "@/services/chaoDeObra";
import type { UnitsByCCItem } from "@/services/gerencial";
import { currentLocalDateInput } from "@/utils/dateInput";

export const CHAO_EMPTY_FILTERS: FilterValues = {
  startDate: currentLocalDateInput(),
  endDate: currentLocalDateInput(),
  costCenter: [],
  constructiveUnit: [],
  itemFilter: [],
  quotationFilter: "",
  purchaseRequestFilter: "",
  orderFilter: "",
  supplierFilter: [],
};

export interface ChaoDeObraListCache {
  hasData: boolean;
  filterValues: FilterValues;
  appliedCostCenter: string[];
  allUnits: ComercialUnitRow[];
  metrics: Record<string, ChaoUnitMetrics>;
  enterpriseGeneralPct: number;
  unitSearch: string;
  constructiveUnitOptions: MultiSelectOption[];
  unitLinksByCc: Record<string, Record<string, string>>;
  unitAvgByCc: Record<string, number>;
  financialDeductionByCc: Record<string, number>;
  gerencialOutcome: OutcomeItem[] | null;
  physicalSeries: ChaoPhysicalMonthPoint[];
  physicalWeekSeries: ChaoPhysicalWeekPoint[];
  unitsByCC: UnitsByCCItem[];
}

export function emptyChaoListCache(): ChaoDeObraListCache {
  return {
    hasData: false,
    filterValues: { ...CHAO_EMPTY_FILTERS, costCenter: [] },
    appliedCostCenter: [],
    allUnits: [],
    metrics: {},
    enterpriseGeneralPct: 0,
    unitSearch: "",
    constructiveUnitOptions: [],
    unitLinksByCc: {},
    unitAvgByCc: {},
    financialDeductionByCc: {},
    gerencialOutcome: null,
    physicalSeries: [],
    physicalWeekSeries: [],
    unitsByCC: [],
  };
}
